import { render } from "./CertificateView.vue?vue&type=template&id=024bbefc&scoped=true"
import script from "./CertificateView.vue?vue&type=script&lang=js"
export * from "./CertificateView.vue?vue&type=script&lang=js"

import "./CertificateView.vue?vue&type=style&index=0&id=024bbefc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024bbefc"]])

export default __exports__